<app-sidenav class="relative z-[1000]"  (collapsedChange)="collapsed = $event"></app-sidenav>
<main class="flex flex-col lg:flex-row h-screen overflow-hidden relative"
  [ngClass]="{ 'ml-64': !collapsed && !showHeader, 'ml-20 ': collapsed && !showHeader, 'mt-12': showHeader}">
  @if (!isIframe) {
  <div class="flex-1 flex flex-col overflow-auto h-max-h-full h-[calc(100vh-64px)] lg:h-screen">

    <router-outlet class=""></router-outlet>
  </div>
  }
</main>